import { styled } from '@mui/system';

export const TitleH3 = styled('h3')({
    color: 'var(--ahg-waterloo-darken1)',
    fontFamily: 'Fira Sans',
    fontSize: '18px',
    fontStyle: 'italic',
    fontWeight: 400,
    lineHeight: '24px',
    textAlign: 'left',
});

export const TitleSpan = styled('span')({
    color: 'var(--ahg-waterloo-darken1) !important',
    fontFamily: 'Open Sans !important',
    fontSize: '14px !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    lineHeight: '19.07px !important',
    textAlign: 'left',
});

export const checkboxStyle = {
 display: 'flex', 
 alignItems: 'center',
 padding: '6px 0 6px 16px'
}


export const gridContainerStyle = {
    display: 'flex',
    flexDirection: 'row',
    gap: '32px',
    width: '100%',
    marginTop: 0,
    marginLeft: 0,
};

export const columnStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    flex: 1,
};

export const gridItemStyle = {
    padding: 10,
    width: '100%',
    maxWidth: '100%',
    alignSelf: 'start',
};

export const gridItemWithPaddingStyle = {
    width: '100%',
    maxWidth: '100%',
    paddingTop: '20px',
};

export const dividerStyle = {
    borderTop: 'solid 1px var(--ahg-gray-lighten4)',
    paddingTop: 16,
    marginTop: 16,
};

export const livenessContainerStyle = {
    display: 'flex',
    gap: '20px',
    paddingLeft: '15px',
    paddingTop: '6px'
};

export const livenessTitleStyle = {
    paddingLeft: '15px',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    paddingTop: '10px'
};

export const selectWithTooltipStyle = {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    width: '100%',
    marginBottom: '8px'
};

export const selectWithTooltipFieldStyle = {
    width: 'calc(100% - 32px)'
};

export const tooltipContainerStyle = {
    alignSelf: 'center',
    width: '24px',
    flexShrink: 0
};

export const standardSelectStyle = {
    width: 'calc(100% - 32px)'
};